
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 20.876v-6.211h14v6.21H4zm9.159-4.647v3.175h.689v-1.252h1.1v-.595h-1.1v-.685h1.335v-.643H13.16zm-3.217 0v3.175h1.113c.224 0 .427-.038.61-.114a1.342 1.342 0 00.771-.823c.07-.195.105-.414.105-.655 0-.218-.031-.423-.094-.615a1.44 1.44 0 00-.281-.503 1.334 1.334 0 00-.465-.34 1.558 1.558 0 00-.646-.125H9.942zm-2.827 0v3.175h.689V18.38h.605a.85.85 0 00.39-.09.918.918 0 00.3-.241 1.167 1.167 0 00.263-.747c0-.131-.024-.261-.073-.39a1.19 1.19 0 00-.202-.344 1.016 1.016 0 00-.307-.246.83.83 0 00-.392-.093H7.115zm1.388 1.275c-.042.053-.091.08-.149.08h-.397v-.621h.38a.2.2 0 01.157.074c.022.025.039.057.052.095.013.039.02.085.02.138 0 .102-.022.18-.063.234zM13.739 1.62l3.044 3.106h-3.044V1.62zm-1.106 4.77H18v7.031H4V1h8.633v5.39zM11.34 18.693a.776.776 0 01-.338.071h-.427v-1.863H11a.81.81 0 01.334.066.675.675 0 01.25.19.86.86 0 01.153.293c.036.114.053.24.053.378 0 .135-.017.26-.053.373a.908.908 0 01-.152.296.688.688 0 01-.247.196z","fill":"#282498","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_pdf.svg